import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocalStorage } from 'react-use';
export const DELAY_BEFORE_START_DRAGGING_IN_MS = 300;
const DEFAULT_POSITION_X = -8;
const DEFAULT_POSITION_Y = -41;
export const useDragging = () => {
  const timeoutId = useRef();
  const [currentPosition, setCurrentPosition] = useState({
    x: DEFAULT_POSITION_X,
    y: DEFAULT_POSITION_Y
  });
  const [hasBeenDragged, setHasBeenDragged] = useLocalStorage('hasConversationalInterfaceBeenDragged', 'no');
  const setHasBeenDraggedLocalStorage = useCallback(() => {
    setHasBeenDragged('yes');
  }, [setHasBeenDragged]);
  const [isDragging, setIsDragging] = useState(false);
  useEffect(() => {
    return () => {
      if (timeoutId.current != null) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [timeoutId]);
  const startDragging = () => {
    if (timeoutId.current != null) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setHasBeenDraggedLocalStorage();
      setIsDragging(true);
    }, DELAY_BEFORE_START_DRAGGING_IN_MS);
  };
  const stopDragging = (_ev, ui) => {
    if (timeoutId.current != null) {
      clearTimeout(timeoutId.current);
    }
    setCurrentPosition({
      x: ui.lastX,
      y: ui.lastY
    });
    setIsDragging(false);
  };
  return {
    currentPosition,
    hasBeenDragged: hasBeenDragged === 'yes',
    isDragging,
    setCurrentPosition,
    startDragging,
    stopDragging
  };
};